import React, { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import { StyleProps } from 'src/lib/styleProps';
import { Checkbox } from '@tenant/components/Checkbox';
import { rgba } from 'polished';
import { useFormContext, Controller } from 'react-hook-form';
import { ConsentDataItem } from 'src/pages/MainPage/components/ConsentForm/consentModels';
import { statuteAndPrivacyPolicyConsentId } from '@tenant/pages/MainPage/components/ConsentForm/ConsentForm.constants';

const Container = styled.div<{ error?: boolean }>`
  border-radius: 0.5rem;
  padding: 1rem 1.625rem;
  background: ${({ theme, error }) =>
    error
      ? (theme.consents.item.errorBg ?? theme.colors.dangerSoft)
      : (theme.consents.item.normalBg ?? rgba(theme.consents.item.bg, 0.3))};
  width: 100%;
`;

export interface ConsentItemProps {
  handleChange?: (v: boolean) => void;
  consent: ConsentDataItem;
}

export const ConsentItem: FC<StyleProps & ConsentItemProps> = ({
  consent,
  className,
  style,
  handleChange,
}) => {
  const theme = useTheme();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const hasError = !!errors[consent.id];

  return (
    <Container error={hasError} className={className} style={style}>
      <Controller
        control={control}
        name={`${consent.id}` as const}
        rules={{ required: consent.mandatory }}
        defaultValue={false}
        render={({ field: { onChange, value, ref } }) => (
          <Checkbox
            error={hasError}
            size={theme.checkbox.default.size ?? 24}
            value={value}
            onChange={(v) => {
              handleChange?.(v);
              onChange(v);
            }}
            inputRef={ref}
            label={consent.label || 'No label for this item'}
            truncateLabel={consent.id !== statuteAndPrivacyPolicyConsentId}
            required={consent.mandatory}
          />
        )}
      />
    </Container>
  );
};
